/* Shared wishlist state for collection and homepage product hearts. */
(function () {
  const key = 'srh_wishlist';

  function readWishlist() {
    try {
      const saved = JSON.parse(localStorage.getItem(key));
      return Array.isArray(saved) ? saved : [];
    } catch (error) {
      return [];
    }
  }

  function itemId(item) {
    if (item && typeof item === 'object') {
      return String(item.id || item.product_id || item.productId || '');
    }
    return String(item || '');
  }

  function syncButtons() {
    const wishlist = readWishlist();
    document.querySelectorAll('.srh-wishlist-btn[data-product-id]').forEach(function (button) {
      const saved = wishlist.some(function (item) {
        return itemId(item) === button.dataset.productId;
      });
      button.classList.toggle('is-wishlisted', saved);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', (saved ? 'Remove ' : 'Add ') + button.dataset.productTitle + (saved ? ' from wishlist' : ' to wishlist'));
      const heart = button.querySelector('.srh-heart');
      if (heart) heart.textContent = saved ? '♥' : '♡';
    });
    document.querySelectorAll('.srh-bottom-nav__wishlist-count').forEach(function (badge) {
      badge.textContent = wishlist.length;
      badge.hidden = wishlist.length === 0;
    });
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('.srh-wishlist-btn[data-product-id]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();

    const wishlist = readWishlist();
    const index = wishlist.findIndex(function (item) {
      return itemId(item) === button.dataset.productId;
    });

    if (index >= 0) {
      wishlist.splice(index, 1);
    } else {
      const card = button.closest('.srh-product-card, .product-card-wrapper');
      const link = card && card.querySelector('a[href*="/products/"]');
      const image = card && card.querySelector('img');
      wishlist.push({
        id: button.dataset.productId,
        title: button.dataset.productTitle,
        url: button.dataset.productUrl || (link && link.href) || '',
        image: button.dataset.productImage || (image && image.src) || '',
        price: button.dataset.productPrice || '',
        variantId: (card && card.querySelector('.srh-cart-btn[data-variant-id]') && card.querySelector('.srh-cart-btn[data-variant-id]').dataset.variantId) || ''
      });
    }

    try {
      localStorage.setItem(key, JSON.stringify(wishlist));
      syncButtons();
      button.classList.remove('srh-heart-pop');
      void button.offsetWidth;
      button.classList.add('srh-heart-pop');
      setTimeout(function () { button.classList.remove('srh-heart-pop'); }, 600);
    } catch (error) {
      console.error('Wishlist could not be saved.', error);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncButtons);
  } else {
    syncButtons();
  }
  document.addEventListener('shopify:section:load', syncButtons);
  window.addEventListener('storage', function (event) {
    if (event.key === key) syncButtons();
  });
})();
